import redirects from "../routes/redirects.json";

const websiteJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Ateno",
  url: "https://ateno.co",
  potentialAction: {
    "@type": "SearchAction",
    target: "https://ateno.co/research?search={search_term_string}",
    "query-input": "required name=search_term_string",
  },
};

const orgJsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Ateno",
  url: "https://ateno.co",
  logo: "https://ateno.co/favicon.png",
  contactPoint: [
    {
      "@type": "ContactPoint",
      telephone: "+1-302-248-1852",
      contactType: "customer support",
      email: "info@ateno.co",
    },
  ],
};

const softwareAppJsonLd = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  name: "Ateno Studio",
  applicationCategory: "DeveloperApplication",
  operatingSystem: "Web",
  url: "https://ateno.co/software",
  description: "Ateno Studio turns real spaces and uploaded objects into spatially aware 3D intelligence for applications, teams, and developers.",
  offers: {
    "@type": "Offer",
    url: "https://ateno.co/software",
    priceCurrency: "USD",
    price: "0",
  },
};

const productsPageJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  name: "Software",
  url: "https://ateno.co/software",
  description: "Explore Ateno's spatial intelligence software for real-time 3D reconstruction, object positioning, and room understanding.",
};

const aboutPageJsonLd = {
  "@context": "https://schema.org",
  "@type": "AboutPage",
  name: "Company",
  url: "https://ateno.co/company",
  description: "Learn about Ateno's mission, leadership, and commercial strategy around spatial intelligence.",
};

const defaultSeo = {
  title: "Ateno — hardware for 3D Gaussian Splatting",
  titleSuffix: false,
  description: "Ateno AX is a coprocessor for 3DGS reconstruction and training. FPGA prototype.",
  type: "website",
  robots: "index,follow",
  jsonLd: null,
};

const routeSeo = {
  "/company/newsroom": {
    title: "Newsroom",
    titleSuffix: true,
    description: "Analysis, announcements and product updates from the Ateno team.",
  },
  "/": {
    title: "Ateno — hardware for 3D Gaussian Splatting",
    titleSuffix: false,
    description: "Ateno AX is a coprocessor for 3DGS reconstruction and training. FPGA prototype.",
    jsonLd: [websiteJsonLd, orgJsonLd],
  },
  "/software": {
    title: "Software",
    description: "Ateno Studio provides spatial intelligence software for real-time 3D reconstruction, object placement, and scene understanding.",
    jsonLd: softwareAppJsonLd,
  },
  "/ax": {
    title: "Ateno AX",
    description: "Ateno AX is a coprocessor for 3DGS reconstruction and training. FPGA prototype.",
  },
  "/company": {
    title: "Company",
    description: "Learn about Ateno's mission, leadership, and commercial strategy around spatial intelligence.",
    jsonLd: [aboutPageJsonLd, orgJsonLd],
  },
  "/careers": {
    title: "Careers at Ateno | Spatial Computing and Hardware Acceleration",
    titleSuffix: false,
    description: "Join Ateno and work on spatial computing, hardware acceleration, 3D vision and real-time spatial intelligence.",
  },
  "/support": {
    title: "Support",
    description: "Find support resources and contact options for Ateno products and services.",
  },
  "/research": {
    title: "Research",
    description: "Product updates, engineering notes, and spatial intelligence research from the Ateno team.",
  },
  "/privacy": {
    title: "Privacy Policy",
    description: "Read how Ateno collects, uses, and protects personal data.",
  },
  "/terms": {
    title: "Terms of Service",
    description: "Review the Ateno terms and conditions for using the website and services.",
  },
  "/cookie": {
    title: "Cookie Policy",
    description: "Learn how Ateno uses cookies and manages consent preferences.",
  },
  "/refund-policy": {
    title: "Refund Policy",
    description: "Review Ateno refund terms for subscriptions, billing errors, and cancellations.",
  },
  "/security": {
    title: "Security",
    description: "Ateno security practices for protecting user data, API keys, and infrastructure.",
  },
};

export function resolveRouteSeo(pathname) {
  pathname = redirects[pathname.replace(/\/$/, "")] || pathname;
  let resolved = { ...defaultSeo, path: pathname };

  if (pathname.startsWith("/team/")) {
    resolved = {
      ...resolved,
      title: "Team",
      description: "Leadership profile at Ateno.",
    };
  } else if (pathname.startsWith("/dashboard") || pathname.startsWith("/profile") || pathname.startsWith("/login") || pathname.startsWith("/signup") || pathname.startsWith("/auth/")) {
    resolved = {
      ...resolved,
      title: "Account",
      description: "Ateno account and workspace pages.",
      robots: "noindex,nofollow",
    };
  } else if (routeSeo[pathname]) {
    resolved = {
      ...resolved,
      ...routeSeo[pathname],
    };
  }

  return resolved;
}
